import PastQuotesTable from "components/billing/PastQuotesTable";
import { Calendar } from "components/calendar/Calendar";
import { Button } from "components/DesignSystem/Button/Button";
import Tab from "components/DesignSystem/Tab/Tab";
import { SendQuoteModal } from "components/SendQuoteModal/SendQuoteModal";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { CalendarYearSelector } from "pages/Calender/CalendarYearSelector";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  useLazyGenerateQuoteSheetLinkQuery,
  useSendQuoteMutation,
} from "store/apis/calendar";
import { RootState } from "store/store";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { EntitySelector } from "components/EntitySelector/EntitySelector";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";

export const CrmQuotes = () => {
  const { uuid: groupId, team } = useCurrentGroupContext();
  const [quoteModalOpen, setQuoteModal] = useState(false);
  const [tab, changeTab] = useState("DEADLINES");
  const entityId = useCurrentEntityId();

  const calendarYear = useSelector((state: RootState) => state.calendar.year);
  const [sendQuote, { isLoading: isSendingQuote }] = useSendQuoteMutation();
  const [
    generateQuoteLink,
    { isLoading: isGeneratingLink, isFetching: isGeneratingLinkAgain },
  ] = useLazyGenerateQuoteSheetLinkQuery();

  const onSubmitSendQuote = async ({
    file,
    recipients,
  }: {
    file: File;
    recipients: string;
  }) => {
    await sendQuote({ groupId, file, recipients, entityId });

    setQuoteModal(false);
  };

  const onGenerateLink = async () => {
    try {
      const { quote_link } = await generateQuoteLink({
        groupId,
        calendarYear,
        entityId,
      }).unwrap();
      if (quote_link) {
        window.open(quote_link);
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="t-flex t-flex-col t-h-full">
        <div className="t-m-0 t-grow">
          <div className="t-flex t-gap-3 t-pt-5 t-px-8 t-items-center t-justify-between t-w-full">
            <ToggleGroup
              className="t-w-80"
              value={tab}
              onValueChange={(v) => changeTab(v)}
            >
              <ToggleGroupItem value="DEADLINES">
                Current deadlines
              </ToggleGroupItem>
              <ToggleGroupItem value="QUOTES">Past Quotes</ToggleGroupItem>
            </ToggleGroup>
            {tab === "DEADLINES" && (
              <div className="t-flex t-gap-2 t-self-end">
                <EntitySelector showOnlyUSEntities />
                <CalendarYearSelector />
              </div>
            )}
          </div>
          {tab === "DEADLINES" && (
            <div className="t-w-full t-overflow-auto">
              <Calendar groupId={groupId} bottomBar={<></>} />
            </div>
          )}
          {tab === "QUOTES" && (
            <div className="t-p-7">
              <PastQuotesTable />
            </div>
          )}
        </div>
        <div className="t-mb-auto">
          <div className="t-hidden t-w-full t-items-center t-bg-surface-lighter-grey md:t-flex">
            <div className="t-flex t-w-full t-justify-between t-py-4 t-pl-5 t-pr-7">
              <div />
              <div className="t-mr-20 t-flex t-gap-4">
                <Button size="small" onClick={() => setQuoteModal(true)}>
                  Send quote
                </Button>
                <Button
                  isLoading={isGeneratingLink || isGeneratingLinkAgain}
                  disabled={isGeneratingLink || isGeneratingLinkAgain}
                  customType="primary"
                  size="small"
                  onClick={onGenerateLink}
                >
                  Generate quote
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SendQuoteModal
        isSubmiting={isSendingQuote}
        members={team}
        isOpen={quoteModalOpen}
        setIsOpen={setQuoteModal}
        onSendQuote={onSubmitSendQuote}
      />
    </>
  );
};
